module.exports = {"confirm":"确认","cancel":"取消","delete":"删除","submit":"提交","refresh":"刷新","loading":"加载中...","pleaseSelect":"请选择","noData":"暂无数据","online":"在线","offline":"离线","yes":"是","no":"否","tips":"提示","iknow":"我知道了","saveSuccess":"保存成功","loginExpired":"登录已过期，将跳转到登录页面！","noPermission":"暂无权限","sunday":"星期日","monday":"星期一","tuesday":"星期二","wednesday":"星期三","thursday":"星期四","friday":"星期五","saturday":"星期六","pleaseSelectOne":"请至少选择一个选项","newChatMessage":"您有新的会话消息"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/common.json
// module id = BBbc
// module chunks = 1